import styled, { createGlobalStyle } from 'styled-components';

// Style global spécifique au module pour éviter les interférences
export const ModuleStyle = createGlobalStyle`
  .tcf-writing-module * {
    box-sizing: border-box;
    font-family: 'Inter', 'Roboto', sans-serif;
  }
`;

// Container principal avec isolation CSS
export const ModuleContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  min-height: 700px;
  position: relative;
  isolation: isolate;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
`;

export const Title = styled.h1`
  color: #2c3e50;
  font-size: 24px;
  margin: 0;
`;

export const TimerContainer = styled.div`
  font-size: 18px;
  font-weight: 600;
  background-color: ${props => (props.isLow ? '#ffeeee' : '#f8f9fa')};
  color: ${props => (props.isLow ? '#dc3545' : '#495057')};
  padding: 10px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  animation: ${props => (props.isLow ? 'pulse 1.5s infinite' : 'none')};
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.7; }
    100% { opacity: 1; }
  }
`;

export const Button = styled.button`
  background-color: ${props => props.primary ? '#3498db' : props.danger ? '#e74c3c' : '#f8f9fa'};
  color: ${props => props.primary || props.danger ? '#fff' : '#495057'};
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.primary ? '#2980b9' : props.danger ? '#c0392b' : '#e9ecef'};
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(1px);
  }
  
  &:disabled {
    background-color: #e9ecef;
    color: #adb5bd;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
`;

// Styles pour la page d'accueil
export const TaskSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
`;

export const WelcomeSection = styled.div`
  max-width: 700px;
  margin: 0 auto 40px auto;
`;

export const WelcomeTitle = styled.h1`
  color: #2c3e50;
  font-size: 32px;
  margin: 0 0 16px 0;
`;

export const WelcomeDescription = styled.p`
  color: #5d6778;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 28px;
`;

export const TaskTypeContainerTitle = styled.h2`
  color: #2c3e50;
  font-size: 22px;
  margin: 0 0 28px 0;
  width: 100%;
  text-align: center;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: #3498db;
    border-radius: 2px;
  }
`;

// Conteneur amélioré pour les cartes
export const TaskTypeContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 1000px;
  margin: 20px auto;
`;

export const TaskTypeCard = styled.div`
  background-color: #fff;
  border: 2px solid ${props => props.selected ? '#3498db' : '#e9ecef'};
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${props => props.selected ? '0 8px 18px rgba(52, 152, 219, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.03)'};
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  
  ${props => props.selected && `
    &:before {
      content: '✓';
      position: absolute;
      top: 12px;
      right: 12px;
      width: 24px;
      height: 24px;
      background: #3498db;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
    }
  `}
  
  &:hover {
    border-color: #3498db;
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }
`;

export const TaskTypeIcon = styled.div`
  font-size: 32px;
  margin-bottom: 12px;
  color: #3498db;
`;

export const TaskTypeTitle = styled.h3`
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 18px;
`;

export const TaskTypeDescription = styled.p`
  margin: 0 0 12px 0;
  color: #6c757d;
  font-size: 15px;
  line-height: 1.5;
  flex-grow: 1;
`;

export const TaskTypeDetails = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-top: 8px;
  font-size: 14px;
  color: #495057;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TaskTypeTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const StartButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  width: 100%;
`;

export const StartButton = styled(Button)`
  padding: 14px 32px;
  font-size: 18px;
  min-width: 220px;
  position: relative;
  overflow: hidden;
  
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background-image: ${props => props.disabled ? 'none' : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 5l7 7-7 7'%3E%3C/path%3E%3C/svg%3E")`};
    background-size: contain;
    transition: transform 0.2s ease;
  }
  
  &:hover:after {
    transform: translateY(-50%) translateX(3px);
  }
  
  ${props => props.disabled && `
    &:after {
      display: none;
    }
  `}
`;

// Styles pour l'interface d'examen
export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 20px;
`;

export const Tab = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  font-weight: 500;
  border-bottom: 3px solid ${props => props.active ? '#3498db' : 'transparent'};
  color: ${props => props.active ? '#3498db' : '#6c757d'};
  transition: all 0.2s ease;
  
  &:hover {
    color: #3498db;
  }
`;

export const TaskContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 400px;
`;

export const TaskHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const TaskTitle = styled.h2`
  margin: 0;
  color: #2c3e50;
  font-size: 18px;
`;

export const InstructionContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: ${props => props.collapsed ? '0px' : '20px'};
  margin-bottom: 16px;
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: ${props => props.collapsed ? '0px' : '400px'};
`;

export const InstructionToggle = styled.button`
  background: none;
  border: none;
  margin-bottom: 1rem;
  color: #3498db;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const EditorContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Editor = styled.textarea`
  width: 100%;
  height: 100%;
  min-height: 250px;
  padding: 16px;
  border: 3px solid #e9ecef;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1.6;
  resize: none;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }
`;

export const EditorFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  font-size: 14px;
  color: #6c757d;
`;

export const WordCount = styled.div`
  color: ${props => props.warning ? '#e67e22' : props.danger ? '#e74c3c' : '#6c757d'};
  font-weight: ${props => (props.warning || props.danger) ? '600' : '400'};
`;

// Styles pour les modales
export const ConfirmationModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalTitle = styled.h3`
  margin-top: 0;
  color: #2c3e50;
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

// Styles pour l'écran de complétion
export const CompletionMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
`;